<template>
	<div class="pick-link">
		<div class="tab-box">
			<div class="tab-item" :class="activeName === '0' ? 'active-tab' : ''" @click="activeChange('0')">添加商品（ {{productNum}} )</div>
			<div class="tab-item" :class="activeName === '1' ? 'active-tab' : ''" @click="activeChange('1')">添加商品大类（ {{bigCateNum}} )</div>
			<div class="tab-item" v-if="showSmall" :class="activeName === '2' ? 'active-tab' : ''" @click="activeChange('2')">添加商品小类（ {{smallCateNum}} )</div>
			<div class="tab-item" :class="activeName === '3' ? 'active-tab' : ''" @click="activeChange('3')">自定义界面（ {{cusNum}} )</div>
		</div>
		<div class="pic-container-box">
			<vuedraggable class="wrapper" v-model="showArr" @end="sortImg">
				<div class="pic-box" v-for="(item, index) in showArr" :key="index">
					<div class="top-box">
						<div>图片：</div>
						<div>
							<ImgUplaod
								:imgSrc.sync="item.imgurl"
								:imgId.sync="item.id"
								:seqnum='index'
								@imgChange='imgChange'
							></ImgUplaod>
						</div>
					</div>
					<div class="bottom-box">
						<div>链接：</div>
						<el-button v-if="activeName === '0'" size="mini" type="primary" @click="addProductClick(index)">+ 添加商品</el-button>
						<div class="product-box" v-if="activeName === '0' && item.targetid !== ''">
							<i class="el-icon-circle-close close-icon" @click="reSetClick(item)"></i>
							<div class="text">{{item.productname}}</div>
						</div>
						<el-select v-if="activeName === '1'" filterable v-model="item.targetid" class="filter-input" size='mini' placeholder="商品大类">
							<el-option :value="bcItem.bc_id" :label="bcItem.bc_name" v-for="(bcItem) in bc" :key="bcItem.bc_id"></el-option>
						</el-select>
						<el-select v-if="activeName === '2'" filterable v-model="item.targetid" class="filter-input" size='mini' placeholder="商品小类">
							<el-option :value="scItem.id" :label="scItem.name" v-for="scItem in categoryList" :key="scItem.id"></el-option>
						</el-select>
						<el-select v-if="activeName === '3'" filterable v-model="item.targetid" class="filter-input" size='mini' placeholder="自定义页面">
							<el-option :value="scItem.id" :label="scItem.styleName" v-for="scItem in cusLIst" :key="scItem.id"></el-option>
						</el-select>
						<el-button v-if="activeName !== '0'" size="mini" type="primary" plain @click="reSetClick(item)">重置</el-button>
					</div>
					<div class="top-box" style="align-items: start;margin-top: 10px;">
						<div>弹窗时间：</div>
						<div>
							<el-radio v-model="item.datetype" :label="0">永久</el-radio><br>
							<el-radio v-model="item.datetype" :label="1">自定义
								<el-date-picker
									v-model="item.dateValue"
									:clearable="false"
									:unlink-panels='true'
									class="time-input"
									size="mini"
									type="datetimerange"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									:default-time="['00:00:00', '23:59:59']"
									format='yyyy-MM-dd HH:mm:ss'
									value-format='yyyy-MM-dd HH:mm:ss'>
								</el-date-picker>
							</el-radio>
						</div>
					</div>
					<i class="el-icon-circle-close close-btn" @click="delClick(index)"></i>
				</div>
			</vuedraggable>
		</div>
		<div class="btn-box"  @click="addClick" :class="(allLength === 3 || allLength > 3) ? 'is-disabled' : ''">
			+ 添加图片链接
		</div>
		<el-dialog title="添加商品" class="dialog-title" :visible.sync="productDialog" width='1000px' :close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>商品名称：</span>
						<el-input
							style="width:150px"
							v-model="keyword"
							size="mini"
							@keyup.enter.native="searchClick">
						</el-input>
					</div>
					<div class="input-box">
						<span>商品大类：</span>
						<el-select v-model="bbcTypeCategory" class="filter-input" size='small' @change="bcChange">
							<el-option value="0" label="全部"></el-option>
							<template v-for="(item) in bcList">
								<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
							</template>
						</el-select>
					</div>
					<div v-if="showSmall"  class="input-box">
						<span>商品小类：</span>
						<el-select v-model="sbcTypeCategory" class="filter-input" size='small'>
							<el-option value="0" label="全部"></el-option>
							<template v-for="(item) in sc">
								<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
							</template>
						</el-select>
					</div>
					<el-button size="small" type="primary" class="btn fx-btn" @click="searchClick">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clearSearch">清空</el-button>
				</div>
				<el-table
					class="grid-content"
					:data="productTableData"
					border
					size='mini'
					height="400"
					ref="table"
				>
					<el-table-column
						width="40"
						key='radio'
						align="center">
						<template slot-scope='scope'>
							<el-radio v-model="chooseId" class='radioClass' @change='radioChange(scope.row)' :label='scope.row.productid'></el-radio>
						</template>
					</el-table-column>
					<el-table-column
						key="productname"
						prop="productname"
						label="商品名称"
						align="center">
					</el-table-column>
					<el-table-column
						key="bbcname"
						prop="bbcname"
						label="商品大类"
						align="center">
					</el-table-column>
					<el-table-column
						v-if="showSmall"
						key="sbcname"
						prop="sbcname"
						label="商品小类"
						align="center">
					</el-table-column>
					<el-table-column
						key="productcode"
						prop="productcode"
						label="spu编号"
						align="center">
					</el-table-column>
				</el-table>
				<div style="display: flex;align-items: center;justify-content: end;height: 40px;">
					<el-pagination
						style="margin: 10px; text-align: center;"
						@size-change="productSizeChange"
						@current-change="productPageChange"
						:current-page="productPagination.page"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="productPagination.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="productTotalCount">
					</el-pagination>
				</div>
				<div class="valet-foot">
					<el-button plain type="primary" size='small' @click='cancelClick'>取消</el-button>
					<el-button plain type="primary" size='small' @click='saveProductClick'>添加</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ImgUplaod from '@/components/picLink/ImgUpload.vue'
import vuedraggable from 'vuedraggable'
export default {
	name: 'pickLink',
	components: {
		vuedraggable,
		ImgUplaod
	},
	props: {
	},
	data () {
		return {
			showSmall: false,
			bc: [],
			sc: [],
			productTableData: [],
			categoryList: [],
			chooseId: '',
			activeName: '0',
			productNum: 0,
			cusNum: 0,
			bigCateNum: 0,
			smallCateNum: 0,
			cusArr: [],
			productArr: [],
			bigCateArr: [],
			smallCateArr: [],
			showArr: [],
			productDialog: false,
			productTotalCount: 0,
			productPagination: {
				page: 1,
				size: 20
			},
			sbcTypeCategory: '0',
			keyword: '',
			bbcTypeCategory: '0',
			chooseIndex: null,
			chooseName: '',
			allLength: 0,
			delArr: [],
			bcList: [],
			cusLIst: []
		}
	},
	created () {
		this.getCategoryList()
		this.getBigCategory()
		this.getBigCategory1()
		this.checkSmall()
		this.getCusList()
	},
	methods: {
		getCusList () {
			let params = {
				styleName: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/style/list`,
				data: params
			}).then(res => {
				this.cusLIst = res.recordList
			})
		},
		checkSmall () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.showSmall = res.bigcategoryview === 1
			})
		},
		initData (list) {
			this.showArr = []
			this.productArr = []
			this.bigCateArr = []
			this.smallCateArr = []
			this.cusArr = []
			this.delArr = []
			list.forEach(item => {
				if (item.type === 1) {
					this.productArr.push(item)
				}
				if (item.type === 2) {
					this.bigCateArr.push(item)
				}
				if (item.type === 3) {
					this.smallCateArr.push(item)
				}
				if (item.type === 4) {
					this.cusArr.push(item)
				}
			})

			switch (this.activeName) {
			case '0':
				this.showArr = this.productArr
				break
			case '1':
				this.showArr = this.bigCateArr
				break
			case '2':
				this.showArr = this.smallCateArr
				break
			case '3':
				this.showArr = this.cusArr
				break
			}
			this.redraw()
		},
		redraw () {
			switch (this.activeName) {
			case '0':
				this.productArr = this.showArr
				break
			case '1':
				this.bigCateArr = this.showArr
				break
			case '2':
				this.smallCateArr = this.showArr
				break
			case '3':
				this.cusArr = this.showArr
				break
			}
			this.productNum = this.productArr.length
			this.bigCateNum = this.bigCateArr.length
			this.smallCateNum = this.smallCateArr.length
			this.cusNum = this.cusArr.length
			this.allLength = this.productNum + this.bigCateNum + this.smallCateNum + this.cusNum
		},
		getAllData () {
			this.redraw()
			let arr = [...this.productArr, ...this.bigCateArr, ...this.smallCateArr, ...this.cusArr]
			return {
				addRotationChartList: arr,
				delRotationChartList: this.delArr
			}
		},
		reSetClick (item) {
			item.targetid = ''
		},
		getCategoryList () {
			let params = {
				disabledFlag: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`,
				data: params
			}).then(res => {
				this.categoryList = res.data
			})
		},
		radioChange (data) {
			this.chooseId = data.productid
			this.chooseName = data.productname
		},
		searchClick () {
			let params = {
				bbcTypeCategory: this.bbcTypeCategory,
				sbcTypeCategory: this.sbcTypeCategory,
				keyword: this.keyword,
				page: this.productPagination.page,
				size: this.productPagination.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/style/productattrplanlist`,
				data: params
			}).then(res => {
				this.productTableData = res.recordList
				this.productTotalCount = res.recordCount
			})
		},
		clearSearch () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.visibleFlag = -1
			this.keyword = ''
			this.planDisabledflag = -1
			this.disabledflag = -1
			this.typeCategory = '0'
			this.searchClick()
		},
		cancelClick () {
			this.productDialog = false
		},
		productSizeChange (val) {
			this.productPagination.size = val
			this.searchClick()
		},
		productPageChange (val) {
			this.productPagination.page = val
			this.searchClick()
		},
		saveProductClick () {
			this.showArr[this.chooseIndex].targetid = this.chooseId
			this.showArr[this.chooseIndex].productname = this.chooseName
			this.productDialog = false
		},
		addProductClick (index) {
			this.chooseIndex = index
			this.productDialog = true
			this.searchClick()
			this.getSmalCategory()
		},
		bcChange (value) {
			this.sbcTypeCategory = '0'
			this.bbcTypeCategory = '' + value
			this.getSmalCategory()
		},
		getBigCategory1 () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bcList = res.data
				}
			})
		},
		getBigCategory () {
			let params = {
				disabledFlag: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bbcTypeCategory
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		imgChange () {
			let data = this.getAllData()
			this.$emit('reloadImg', data)
		},
		addClick () {
			if (this.allLength < 3) {
				let row = {
					chartid: '',
					imgurl: '',
					targetid: '',
					type: (+this.activeName + 1) + '',
					datetype: 0,
					dateValue: []
				}
				this.showArr.push(row)
				this.redraw()
				let data = this.getAllData()
				this.$emit('reloadImg', data)
			}
		},
		delClick (index) {
			this.delArr.push(this.showArr[index])
			this.showArr.splice(index, 1)
			this.redraw()
			let data = this.getAllData()
			this.$emit('reloadImg', data)
		},
		activeChange (val) {
			switch (this.activeName) {
			case '0':
				this.productArr = this.showArr
				break
			case '1':
				this.bigCateArr = this.showArr
				break
			case '2':
				this.smallCateArr = this.showArr
				break
			case '3':
				this.cusArr = this.showArr
				break
			}
			this.activeName = val
			switch (this.activeName) {
			case '0':
				this.showArr = this.productArr
				break
			case '1':
				this.showArr = this.bigCateArr
				break
			case '2':
				this.showArr = this.smallCateArr
				break
			case '3':
				this.showArr = this.cusArr
				break
			}
		},
		sortImg () {
			console.log(this.showArr)
		}
	}
}
</script>

<style lang="stylus" scoped>
.pick-link{
    height: 100%;
    width: 100%;
    overflow: auto
	display: flex;
	flex-direction: column
	.tab-box{
		height: 40px;
		font-size: 14px;
		font-weight: bold;
		border-bottom: 1px solid #C1C1C1;
		display: flex;
		flex-direction: row;
		margin: 10px 20px;
		box-sizing: border-box
	}
	.tab-item{
		flex:1;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer
	}
	.active-tab{
		border-bottom: 2px solid var(--fx-primary-color)
		color: var(--fx-primary-color)
	}
	.btn-box{
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--fx-primary-color);
		border: 2px solid var(--fx-primary-color);
		font-weight: bold;
		height: 40px;
		border-radius: 4px;
		margin: 20px 40px;
		box-sizing: border-box;
		cursor: pointer
	}
	.is-disabled {
		color: #8cc5ff;
		background-color: #ecf5ff;
		border-color: #d9ecff;
		cursor: not-allowed;
	}
	.pic-container-box{
		margin: 0 20px;
		box-sizing: border-box
	}
	.pic-box{
		display: flex;
		height: 200px;
		margin-bottom: 15px;
		background-color: #fff;
		flex-direction: column;
		padding: 10px 20px;
		font-weight: 600;
		color: #333333;
		font-family: Lantinghei SC;
		position: relative
		.close-btn{
			position: absolute;
			right:-8px;
			top: -8px;
			font-size: 20px;
			cursor: pointer
		}
		.top-box{
			height: 100px;
			display: flex;
			flex-direction: row;
			align-items: center;
			text-align: left
		}
		.bottom-box{
			flex:1;
			display: flex;
			flex-direction: row;
			align-items: center;
			text-align: left;
			margin-top: 10px
		}
		.filter-input{
			margin-right:10px;
		}
	}
	.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.filter-input{
			width: 120px
		}
	}
	.valet-foot{
		height :40px;
		display :flex;
		align-items center;
		justify-content :center
	}
	.product-box{
		width: 150px;
		height: 32px;
		margin-left: 20px;
		border: 1px dashed #000000;
		position: relative
		.text{
			padding: 0 5px;
			width: 150px;
			height: 32px;
			line-height: 32px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			text-align: center;
			}
		.close-icon{
			position: absolute;
			top:-9px;
			right:-9px;
			font-size:18px;
		}
	}
}
</style>
<style lang="stylus">
.pick-link {
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
